interface IAction {
  id: string;
  name: string;
  action: string | "";
  to_perform: string;
  performed_by_user: string;
  performed_at: string;
}

export function transformToBackendAction(data: IAction[]) {
  return {
    actions: data,
  };
}

export function transformFromBackendAction(backendType: IAction[]) {
  return backendType;
}
